var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3847 0H2.61527C1.17089 0 0 1.16259 0 2.59671V22.4033C0 23.8374 1.17089 25 2.61527 25H37.3847C38.8291 25 40 23.8374 40 22.4033V2.59671C40 1.16259 38.8291 0 37.3847 0Z",
    fill: "#2478BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42874 8.45605L3.73206 16.5736H8.15733L8.70569 15.2791H9.95966L10.508 16.5736H15.3781V15.5837L15.8114 16.5736H18.3309L18.7642 15.5646V16.5736H28.8917L30.1226 15.3133L31.2769 16.5736L36.4768 16.5851L32.7686 12.5377L36.4768 8.45605H31.3574L30.1571 9.69349L29.0412 8.45605H18.0241L17.0769 10.5502L16.1105 8.45605H11.6968V9.41174L11.2059 8.45605H7.43256H7.42874ZM8.28387 9.60973H10.439L12.8894 15.1154V9.60973H15.2516L17.1459 13.5581L18.8907 9.60973H21.2414V15.4352H19.8111L19.7995 10.87L17.7135 15.4352H16.4327L14.3351 10.87V15.4352H11.3938L10.8378 14.1292H7.82371L7.26767 15.4352H5.69161L8.28387 9.60973ZM22.549 9.60973H28.3625L30.1418 11.5173L31.9786 9.60973H33.758L31.0545 12.5377L33.758 15.4314H31.8981L30.1188 13.501L28.2743 15.4314H22.549V9.60973ZM9.33075 10.5959L8.33756 12.9222H10.3201L9.32692 10.5959H9.33075ZM23.9832 10.8167V11.879H27.1546V13.0631H23.9832V14.2244H27.5419L29.1946 12.5148L27.6109 10.8129H23.9832V10.8167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.0b894be645e26cc47199970509ccfade.svg";
export { ForwardRef as ReactComponent };